/* eslint-disable react/button-has-type */
/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import './checkin.css';
import { FormControl, MenuItem } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import ConnectWithoutContactOutlinedIcon from '@mui/icons-material/ConnectWithoutContactOutlined';
import SupervisedUserCircleOutlinedIcon from '@mui/icons-material/SupervisedUserCircleOutlined';

function SimpleForm({
  name,
  setName,
  phone,
  setPhone,
  email,
  setEmail,
  assistedBy,
  setAssistedBy,
  ReferredBy,
  setReferredBy,
  agreeToggle,
  setAgreeToggle,
  handleSubmit,
  data,
  users,
  companyid,
}) {
  const disabled = name?.length < 5 || (phone.length < 9 && email.length < 8);

  const handleReferral = (e) => {
    const { value } = e.target;

    if (Number.isNaN(Number(value))) {
      if (value.includes('@')) {
        // console.log('string value', value,typeof (value));
        setReferredBy((prevVal) => ({
          ...prevVal,
          email: value,
        }));
      } else {
        // console.log('code', value);
        setReferredBy((prevVal) => ({
          ...prevVal,
          code: value,
        }));
      }
    } else {
      // console.log('number value', value,Number(value), typeof Number(value));
      setReferredBy((prevVal) => ({
        ...prevVal,
        phone: value,
      }));
    }
    // if (Number(value) !== "NaN" && typeof Number(value) === "number") {

    // }
    // if (Number(value) === "NaN" && typeof value === "string") {
    //   console.log('string value', value,typeof (value));
    //   if (value.includes("@")) {
    //     setReferredBy((prevVal) => {
    //       return {
    //         ...prevVal,
    //         email: value,
    //       };
    //     });
    //   } else {
    //     console.log('code', value);
    //     setReferredBy((prevVal) => {
    //       return {
    //         ...prevVal,
    //         code: value,
    //       };
    //     });
    //   }
    // }
  };
  return (
    <Box sx={{ width: '100%' }}>
      <Stack spacing={2}>
        <TextField
          variant="outlined"
          placeholder="Full name"
          type="text"
          value={name}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PersonOutlineIcon
                  fontSize="medium"
                  className="text-slate-400"
                />
              </InputAdornment>
            ),
          }}
          sx={{
            '& label': { paddingLeft: (theme) => theme.spacing(2) },
            '& input': { paddingLeft: (theme) => theme.spacing(1) },
            '& fieldset': {
              paddingLeft: (theme) => theme.spacing(2.5),
              borderRadius: '12px',
              borderColor: '#e2e8f0',
            },
          }}
          onChange={(e) => setName(e.target.value)}
        />
        <TextField
          variant="outlined"
          placeholder="Phone"
          type="number"
          value={phone}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LocalPhoneOutlinedIcon
                  fontSize="medium"
                  className="text-slate-400"
                />
              </InputAdornment>
            ),
          }}
          sx={{
            '& label': { paddingLeft: (theme) => theme.spacing(2) },
            '& input': { paddingLeft: (theme) => theme.spacing(1) },
            '& fieldset': {
              paddingLeft: (theme) => theme.spacing(2.5),
              borderRadius: '12px',
              borderColor: '#e2e8f0',
            },
          }}
          onChange={(e) => setPhone(e.target.value)}
        />

        <TextField
          variant="outlined"
          placeholder="Email"
          type="text"
          value={email}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <MailOutlineOutlinedIcon
                  fontSize="medium"
                  className="text-slate-400"
                />
              </InputAdornment>
            ),
          }}
          sx={{
            '& label': { paddingLeft: (theme) => theme.spacing(2) },
            '& input': { paddingLeft: (theme) => theme.spacing(1) },
            '& fieldset': {
              paddingLeft: (theme) => theme.spacing(2.5),
              borderRadius: '12px',
              borderColor: '#e2e8f0',
            },
          }}
          onChange={(e) => setEmail(e.target.value)}
        />
        {companyid !== 'ee7fc816-6be8-4098-aa08-b0c4355b143f' && (
          <div className="flex flex-col space-y-4">
            <FormControl>
              <InputLabel id="form-label" style={{ color: '#94a3b8', fontWeight: 400 }}>&nbsp;&nbsp;&nbsp;&nbsp;Assisted By</InputLabel>
              <Select
                labelId="form-label"
                value={assistedBy}
                label="Assisted By"
                onChange={(e) => setAssistedBy(e.target.value)}
                sx={{
                  // '& label': { paddingLeft: (theme) => theme.spacing(2) },
                  '& input': { paddingLeft: (theme) => theme.spacing(1) },
                  '& fieldset': {
                    paddingLeft: (theme) => theme.spacing(2.5),
                    borderRadius: '12px',
                    borderColor: '#e2e8f0',
                  },
                }}
                startAdornment={(
                  <InputAdornment>
                    <SupervisedUserCircleOutlinedIcon fontSize="medium" className="mr-[15px] text-slate-400" />
                  </InputAdornment>
                )}
              >
                {users?.map((user) => (
                  <MenuItem value={user.account_id} key={user.account_id}>{user.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              variant="outlined"
              placeholder="Referred by (code, email or phone)"
              // value={ReferredBy}
              onChange={handleReferral}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <ConnectWithoutContactOutlinedIcon
                      fontSize="medium"
                      className="text-slate-400"
                    />
                  </InputAdornment>
                ),
              }}
              sx={{
                // '& label': { paddingLeft: (theme) => theme.spacing(2) },
                '& input': { paddingLeft: (theme) => theme.spacing(1) },
                '& fieldset': {
                  paddingLeft: (theme) => theme.spacing(2.5),
                  borderRadius: '12px',
                  borderColor: '#e2e8f0',
                },
              }}
            />
          </div>
        )}

        <div className="flex items-start gap-1 rounded-xl bg-slate-50 p-2 pr-4">
          <div className="shrink-0">
            <Checkbox
              checked={agreeToggle}
              onChange={(e) => setAgreeToggle(e.target.checked)}
            />
          </div>
          <div className="pt-2 text-[13px] leading-relaxed text-slate-600">
            I agree to receive SMS from
            {' '}
            {data?.company?.name}
            . Message and data
            rates may apply. Text STOP to unsubscribe.
          </div>
        </div>

        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={disabled}
          disableElevation
          className="qs-btn"
          sx={{
            textTransform: 'none',
            borderRadius: '12px',
            fontWeight: 500,
            fontSize: '16px',
            py: 1.5,
            backgroundColor: '#2563eb',
            '&:hover': { backgroundColor: '#1d4ed8' },
          }}
        >
          Submit
        </Button>
        {/* <button className="btn-chcekin" onClick={handleSubmit} disabled={disabled}>
          Submit
        </button> */}
      </Stack>
    </Box>
  );
}

export default SimpleForm;
